/**
 * Ключ `forms` registry при расхождении FormProvider slot и schema formId
 * (SAME_WINDOW в диалоге: слот остаётся id первой формы, registry — текущая schema).
 *
 * Если для registry formId уже есть bucket — он приоритетнее stale `forms[slot]`
 * от предыдущего шага визарда.
 */
export function resolveFormsStorageFormIdForContext(
  formId: string | number | undefined,
  pageDataSlot: string | undefined,
  hasFormsKey: (key: string) => boolean,
  resolveFallback: (formId: string | number | undefined) => string,
): string {
  const preferredSlot = String(pageDataSlot ?? '').trim()
  const fid = String(formId ?? '').trim()

  if (preferredSlot && fid && preferredSlot !== fid && hasFormsKey(fid)) {
    return fid
  }
  if (preferredSlot && hasFormsKey(preferredSlot)) {
    return preferredSlot
  }
  return resolveFallback(formId) || fid
}
